import React from "react";
import {
  Navigate,
  Route,
  Routes as ReactRoutes,
  BrowserRouter as Router,
} from "react-router-dom";
import logo from "./logo.svg";
import "./App.css";
import Home from "./pages/Home";
import { IConfig } from "./types/IConfig";
import { PrivateRoute } from "./pages/PrivateRoute/PrivateRoute";
import { AuthProvider } from "./utility/useAuth";
import Login from "./pages/Login";
import Logout from "./pages/Logout";
import { DefaultLayout } from "./layouts/Default";
import JobPage from "./pages/JobPage";
import BomPage from "./pages/BomPage";
import GuestLayout from "./layouts/Guest";
import JobImagesPage from "./pages/JobImagesPage";
import SimilarJobsImagesPage from "./pages/SimilarJobsImages";
import { ImagesPage } from "./pages/ImagesPage/ImagesPage";
import JobDocumentsPage from "./pages/JobDocuments";
import ThirdPartyVisualInspectionPage from "./pages/ThirdPartyVisualInspectionPage";
import BarcodePage from "./pages/BarcodePage";
import CncCardVisualInspectionPage from "./pages/CncCardVisualInspectionPage";
import FactoryAcceptanceInspectionPage from "./pages/FactoryAcceptanceInspectionPage";
import PackagingInspectionPage from "./pages/PackagingInspectionPage";
import ReportIssuePage from "./pages/ReportIssuePage";
import DownloadPage from "./pages/DownloadPage";

// Merge our Window interface into the global scope
declare global {
  interface Window {
    config: IConfig;
  }
}

const RoutesWrap: React.FC = () => {
  return (
    <Router>
      <App />
    </Router>
  );
};

function App() {
  return (
    <div className="App">
      {/* <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.tsx</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header> */}
      <AuthProvider authConfig={null}>
        <ReactRoutes>
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Navigate to="/home" />
              </PrivateRoute>
            }
          />
          <Route
            path="/login"
            element={
              <GuestLayout>
                <Login />
              </GuestLayout>
            }
          />
          <Route
            path="/logout"
            element={
              <GuestLayout>
                <Logout />
              </GuestLayout>
            }
          />
          <Route
            path="/home"
            element={
              <PrivateRoute>
                <DefaultLayout>
                  <Home />
                </DefaultLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="job/:jobNumber"
            element={
              <PrivateRoute>
                <DefaultLayout>
                  <JobPage />
                </DefaultLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="bom/:jobNumber"
            element={
              <PrivateRoute>
                <DefaultLayout>
                  <BomPage />
                </DefaultLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/images"
            element={
              <PrivateRoute>
                <DefaultLayout>
                  <ImagesPage/>
                </DefaultLayout>
              </PrivateRoute>
            }
          />
           <Route
            path="job-images/:jobNumber"
            element={
              <PrivateRoute>
                <DefaultLayout>
                  <JobImagesPage />
                </DefaultLayout>
              </PrivateRoute>
            }
          />
           <Route
            path="similar-jobs-images/"
            element={
              <PrivateRoute>
                <DefaultLayout>
                  <SimilarJobsImagesPage/>
                </DefaultLayout>
              </PrivateRoute>
            }
          />
           <Route
            path="job-documents/:jobNumber"
            element={
              <PrivateRoute>
                <DefaultLayout>
                  <JobDocumentsPage />
                </DefaultLayout>
              </PrivateRoute>
            }
          />
           <Route
            path="/reportIssue"
            element={
              <PrivateRoute>
                <DefaultLayout>
                  <ReportIssuePage/>
                </DefaultLayout>
              </PrivateRoute>
            }
          />
           <Route
            path="downloads"
            element={
              <PrivateRoute>
                <GuestLayout>
                  <DownloadPage/>
                </GuestLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="third-party-visual-inspection/:sequence?"
            element={
              <PrivateRoute>
                <GuestLayout>
                  <ThirdPartyVisualInspectionPage/>
                </GuestLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="cnc-route-card-visual-inspection/:sequence?"
            element={
              <PrivateRoute>
                <GuestLayout>
                  <CncCardVisualInspectionPage/>
                </GuestLayout>
              </PrivateRoute>
            }
          />
           <Route
            path="factory-acceptance-inspection/:sequence?"
            element={
              <PrivateRoute>
                <GuestLayout>
                  <FactoryAcceptanceInspectionPage/>
                </GuestLayout>
              </PrivateRoute>
            }
          />
           <Route
            path="packaging-inspection/:sequence?"
            element={
              <PrivateRoute>
                <GuestLayout>
                  <PackagingInspectionPage/>
                </GuestLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="barcode/:sequenceNumber"
            element={
              <PrivateRoute>
                <GuestLayout>
                  <BarcodePage />
                </GuestLayout>
              </PrivateRoute>
            }
          />
        </ReactRoutes>
      </AuthProvider>
    </div>
  );
}

//export default App;

export default RoutesWrap;
